import styled from 'styled-components';
import { colors, scaffolding } from '@alixpartners/ui-components';

// Main container for the error module
export const ErrorContainer = styled.section`
  margin: 0 auto;
  min-height: 100vh;
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  overflow: hidden;
`;

// Sub headers and text areas
export const ErrorHeader = styled.h2`
  color: ${colors.green1};
  margin-bottom: ${scaffolding.lg};
`;

export const ErrorTitle = styled.h6`
  margin-bottom: ${scaffolding.lg};
`;

export const ErrorDescription = styled.p`
  margin-bottom: ${scaffolding.lg};
`;
